import repository from '@/repositories/repository'
const resource = 'stock-suppliers'
export default {
  index (storeId, params) {
    return repository.get(`${resource}/store/${storeId}`, { params })
  },
  inventorySummary (params) {
    return repository.get(`${resource}/\/summary`, { params })
  },
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  /**
   * Description
   * @param {string} storeId
   * @param {any} params
   * @param {AbortController} [controller]
   */
  paginate (storeId, params, controller = null) {
    return repository.get(`${resource}/store/${storeId}/paginate`, { params, signal: controller?.signal })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
  storeList (supplierId, storeId) {
    return repository.get(`${resource}/supplier/${supplierId}/store/${storeId}`)
  },
  importExcel (data) {
    return repository.post(`${resource}/import/excel`, { data })
  },
  inventoryWorth () {
    return repository.get(`${resource}/inventory-worth`)
  },
  transfer (id, data) {
    return repository.put(`${resource}/${id}/transfer`, data)
  },
}
